import React from 'react';
import styled from 'styled-components'

const YearSelector = (props) => {

    const years =['2027','2026','2025','2024','2023'];

    return (
        <Container>
            <Heading>Sales Insights</Heading>
            <Select value={props.year} onChange={(e) => props.setYear(e.target.value)}>
                {years.map(y => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </Select>
        </Container>
    )
}

export default YearSelector;

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    margin-top: 40px;
`;


const Heading = styled.h1`
  font-size:2rem;
  margin: 0;
  padding: 0;
  color: #000;
  text-align: center;
`;

const Select = styled.select`
  appearance: none;
  padding: 8px 28px 8px 12px;
  border-radius: 8px;
  border: 1px solid #d9dde3;
  background: #fff url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M6 8l4 4 4-4" stroke="%236a7380" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') no-repeat right 8px center;
  color: #0b1220;
  font-size: 0.95rem;
  cursor: pointer;
  &:hover { border-color: #c7ccd5; }
  &:focus { outline: none; border-color: #9aa4b2; box-shadow: 0 0 0 3px rgba(26,115,232,0.15); }
`;


